import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const BlockProjectNotifPageUI = ({context, messageList, projectNotFound, projectName,
    onSubmit, submitted, successMsg, errorList, setErrorList, onCancel
  }) =>
  <PublicPageSF context={context} className='pg_blk_prj_eml' centered={!messageList || projectNotFound}
    messageList={messageList} headerMessageKey='c_opt_out_prj_email_q'>
    {
      !messageList &&
      <SpinnerComponentUI />
    }

    {
      messageList && projectNotFound &&
      <div className='g_text_center'>
        <MessageUI messageList={messageList} messageKey='c_not_found' />
        <div className='g_m_top_100'>
          <ButtonLinkUI to='/' messageList={messageList} labelKey='c_continue' transparent={true} />
        </div>
      </div>
    }

    {
      messageList && !projectNotFound &&
      <React.Fragment>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_opt_out_prj_email_q' />
        <CardUI>
          <FormSF context={context} messageList={messageList}
              buttonMessageKey='c_opt_out' cancelMessageKey='c_cancel'
              onSubmit={onSubmit} onCancel={onCancel} busy={submitted}
              successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}>
            <MessageUI messageList={messageList} messageKey='c_opt_out_prj_email_d' args={[projectName]} />
          </FormSF>
        </CardUI>
      </React.Fragment>
    }
  </PublicPageSF>

export default BlockProjectNotifPageUI
